import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiV1 } from "../Auth/Interceptor";

const initialStateValue = {
    section: 'eligible-orders',
    subSection: 'sales-summary',
}

const financeManagementSlice = createSlice({
    name: 'financeManagement',
    initialState: initialStateValue,
    reducers: {
        changeSection: (state, action) => {
            state.section = action.payload;
        },
        changeSubSection: (state, action) => {
            state.subSection = action.payload;
        },
    },
    extraReducers: (builder) => {
    },
});

export const {
    changeSection,
    changeSubSection,
} = financeManagementSlice.actions;

export {
}

export default financeManagementSlice.reducer;
